import Field from './Field'

export default function (label, key, rules, options, on) {
  Field.call(this, label, key, rules, options, on)
  this.type = 'date-picker'
  this.subType = 'datetimerange'
}



// WEBPACK FOOTER //
// ./packages/helper/fields/FieldDatetimeRange.js